import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'

class OfferPRService {
  constructor() {
    this.resource = API_RESOURCE.OFFER
  }

  splitCostBudget = async ({ offerId, costBudgetIndex, ...data }) => {
    const response = await axios.post(`${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/split`, data)
    return response.data
  }

  submitPR = async ({ offerId, costBudgetIndex, vendorSelectionIndex, submissionIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}/submit`,
      data
    )
    return response.data
  }

  resubmitPR = async ({ offerId, costBudgetIndex, vendorSelectionIndex, submissionIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}/resubmit`,
      data
    )
    return response.data
  }
  updatePRSubmission = async ({ offerId, costBudgetIndex, vendorSelectionIndex, submissionIndex, ...data }) => {
    const response = await axios.patch(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}`,
      data
    )
    return response.data
  }
  approvePR = async ({ offerId, costBudgetIndex, vendorSelectionIndex, submissionIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}/approve`,
      data
    )
    return response.data
  }
  rejectPR = async ({ offerId, costBudgetIndex, vendorSelectionIndex, submissionIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}/reject`,
      data
    )
    return response.data
  }
  onHoldPR = async ({ offerId, costBudgetIndex, vendorSelectionIndex, submissionIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}/onHold`,
      data
    )
    return response.data
  }

  selectNewQuotationForOnHold = async ({
    offerId,
    costBudgetIndex,
    vendorSelectionIndex,
    submissionIndex,
    ...data
  }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}/selectNewQuotationForOnHold`,
      data
    )
    return response.data
  }
  archivePR = async ({ offerId, costBudgetIndex, vendorSelectionIndex, submissionIndex }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}/archive`
    )
    return response.data
  }
  deletePR = async ({ offerId, costBudgetIndex, vendorSelectionIndex, submissionIndex }) => {
    const response = await axios.delete(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}`
    )
    return response.data
  }
  batchApprovePR = async (data) => {
    const response = await axios.put(`${this.resource}/PR/batchApprove`, data)
    return response.data
  }

  previewWorkInstructionDocument = async ({
    offerId,
    costBudgetIndex,
    vendorSelectionIndex,
    submissionIndex,
    ...data
  }) => {
    const response = await axios.post(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}/workInstruction/preview`,
      data,
      { responseType: 'blob' }
    )
    return response
  }
}
export default OfferPRService
